// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"447edca6","396":"b9a71cdc","453":"8421f433","455":"652a2ae9","977":"391d53f5"}[chunkId] + ".chunk.js";
};